import z from "zod/v4";
// TODO: schemaをcsv-validator.tsにベタ書きしているので、
// accountsもlogiも使える場所に移動したい
// schemaを変更したら、csv-validator.tsも変更すること
const PasswordSchema = z
    .string()
    .min(8)
    .max(100)
    .regex(/^(?=.*[a-z])/, "小文字のアルファベットを少なくとも１つ含めて入力してください。")
    .regex(/^(?=.*[A-Z])/, "大文字のアルファベットを少なくとも１つ含めて入力してください。")
    .regex(/^(?=.*\d)/, "数字を少なくとも１つ含めて入力してください。")
    .regex(/^(?=.*[!"#$%&'()=~|\-^\\@[;:\],./"`{+*}>?_])/, '記号を少なくとも１つ含めて入力してください。利用可能な記号（!"#$%&\'()=~|-^\\@[;:],."`{+*}>?_）')
    .describe("パスワード")
    .brand();
export const Password = {
    schema: PasswordSchema,
    of: (password) => Password.schema.parse(password),
};
//# sourceMappingURL=password.js.map